import { Deserializable } from './deserializable.model';
import { Day } from './day.enum';
import { Time } from '@angular/common';

export class Schedule implements Deserializable {
   public days: Day[] ;
   public start: Time = {hours: 0, minutes: 0};
   public end: Time = {hours: 0, minutes: 0};

   deserialize(input: any): this {
      this.days = input.days.map(d => new Day().deserialize(d));

      /* HH:MM:SS */
      let parts = input.start_time.split(':');
      this.start.hours = parseInt(parts[0], 10);
      this.start.minutes = parseInt(parts[1], 10);
      parts = input.end_time.split(':');
      this.end.hours = parseInt(parts[0], 10);
      this.end.minutes = parseInt(parts[1], 10);

      return this;
   }
}
